import { Gift, X } from "lucide-react";

const assetBase = `${process.env.PUBLIC_URL || ""}/game-assets`;

// Landing overlay for shareable "?promo=CODE" ad links (anonymous visitors).
// Shows the free character and drives a sign-up to auto-claim it.
export default function PromoWelcome({ promo, onSignUp, onClose }) {
  if (!promo) return null;
  return (
    <div className="absolute inset-0 z-[10060] overflow-y-auto overscroll-contain flex items-start justify-center bg-black/85 p-4 scanlines" data-testid="promo-welcome">
      <div className="pixel-card bg-[#141414] p-6 md:p-8 w-full max-w-sm pop-in text-center relative my-auto">
        <button data-testid="promo-welcome-close" onClick={onClose} className="pixel-btn bg-black/55 text-white p-2 absolute top-3 right-3">
          <X size={16} strokeWidth={2.5} />
        </button>
        <p className="font-pixel text-[10px] text-[#FFEB3B] pixel-stroke flex items-center justify-center gap-2 mb-4">
          <Gift size={14} /> FREE CHARACTER
        </p>
        <div className="flex justify-center mb-4">
          <img
            src={`${assetBase}/${promo.char_id}.webp`}
            alt={promo.char_name}
            className="h-40 w-auto drop-shadow-[0_0_18px_rgba(233,30,99,0.6)] float-bob"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        </div>
        <h2 className="font-pixel text-base text-[#E91E63] pixel-stroke leading-relaxed" data-testid="promo-welcome-title">
          Sign up to get<br />{promo.char_name} FREE!
        </h2>
        <p className="font-vt text-lg text-white/70 mt-3">
          Create your free account and {promo.char_name} unlocks instantly. Save your scores & climb the leaderboard.
        </p>
        <button
          data-testid="promo-welcome-signup"
          onClick={onSignUp}
          className="pixel-btn bg-[#0067C6] text-white px-6 py-3 text-xs w-full mt-5 flex items-center justify-center gap-2"
        >
          <Gift size={14} /> Claim {promo.char_name}
        </button>
        <button data-testid="promo-welcome-skip" onClick={onClose} className="font-vt text-lg text-white/50 hover:text-white mt-3">
          Maybe later
        </button>
      </div>
    </div>
  );
}
